import {GET_PROP, GET_PROPS} from "./keys";

export default {
    [GET_PROP]: (state) => (target, key) => !!state.props[target] ? state.props[target][key] : null,
    [GET_PROPS]: (state) => (target) => state.props[target] || {},
}